<template>
  <div class="app-page box-card">
    <div class="box-card-content">
      <!-- <div class="countrys">
        <div class="countrys-item" :class="[queryForm.account_market === item.id ? 'active' : '', ` item${item.id}`]"
          @click="onAccountMarket(item.id)" v-for="(item, key) in userInfo.national_markets" :key="key"></div>
      </div> -->

      <div class="reset-query query">
        <el-form :inline="true" :model="queryForm">
          <el-form-item label="代理姓名/代理ID/用户ID/交易账号">
            <template slot="label">
              <I18Lang id="proxymoneymanage26" defaultText="代理姓名/代理ID/用户ID/交易账号" />
            </template>
            <el-input style="width:250px" :placeholder="$t('proxymoneymanage62')" v-model="queryForm.name"></el-input>
          </el-form-item>

          <!-- <el-form-item label="账户类型">
            <template slot="label">
              <I18Lang id="proxymoneymanage28" defaultText="账户类型" />
            </template>
            <el-select v-model="queryForm.account_mode" :placeholder="$t('public24')">
              <el-option :label="$t('public18')" value=""></el-option>
              <el-option v-for="(item, key) in transferAccountTypes" :label="item" :value="key" :key="key"></el-option>
            </el-select>
          </el-form-item> -->

          <el-form-item label="转账时间">
            <template slot="label">
              <I18Lang id="my70" defaultText="转账时间" />
            </template>
            <el-date-picker style="width:220px" v-model="queryDate" type="daterange" @change="dateChange"
              value-format="yyyy-MM-dd" range-separator="-" :start-placeholder="$t('public22')"
              :end-placeholder="$t('public23')"></el-date-picker>
          </el-form-item>

          <div class="btn kg-btn2" @click="queryQuery">
            <I18Lang id="my85" defaultText="查询" />
          </div>
          <div class="btn kg-refresh btn-query-refresh" @click="resetQuery"></div>

        </el-form>

        <div class="btn kg-btn2" @click="importData">
          <I18Lang id="my137" defaultText="导出" />
        </div>

      </div>

      <div class="statistics">
        <I18Lang id="public25" defaultText="总佣金" />：
        <span class="num">{{ total_commission }}</span>
      </div>

      <div class="reset-table table">
        <el-table :data="tableData.list" style="width: 100%">
          <el-table-column label="代理姓名" width="180">
            <template slot="header">
              <I18Lang id="proxymoneymanage35" defaultText="代理姓名" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.username }}
            </template>
          </el-table-column>
          <el-table-column label="代理ID" width="120">
            <template slot="header">
              <I18Lang id="proxymoneymanage36" defaultText="代理ID" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.account_id }}
            </template>
          </el-table-column>
          <!--
          <el-table-column label="代理等级">
            <template slot="header">
              <I18Lang id="proxymoneymanage37" defaultText="代理等级" />
            </template>
            <template slot-scope="{row}" v-if="row.user">
              {{ row.user.identity }}
            </template>
          </el-table-column>
          <el-table-column width="110px" label="账户类型">
            <template slot="header">
              <I18Lang id="proxymoneymanage63" defaultText="账户类型" />
            </template>
            <template slot-scope="scope">
              {{ transferAccountTypes[+scope.row.account_model] }}
            </template>
          </el-table-column>

          <el-table-column width="110px" label="交易费用($)" prop="trade_fee">
            <template slot="header">
              <I18Lang id="proxymoneymanage40" defaultText="交易费用($)" />
            </template>
            <template slot-scope="{row}">
              {{ Number(row.trade_price).toFixed(2) }}
            </template>
          </el-table-column>

          <el-table-column width="120" :label="`${$t('proxymoneymanage41', { n: currMarket })}`" prop="trade_fee_local">
            <template slot-scope="{row}">
              {{ Number(row.trade_fee_local).toFixed(2) }}
            </template>
          </el-table-column>
          -->
          <el-table-column width="120" :label="`${$t('proxymoneymanage40')}`" prop="trade_fee_local">
            <template slot-scope="{row}">
              {{ Number(row.trade_fee_local).toFixed(2) }}
            </template>
          </el-table-column>

          <el-table-column width="110px" label="返佣比例" prop="commission_rate">
            <template slot="header">
              <I18Lang id="proxymoneymanage39" defaultText="返佣比例" />
            </template>
          </el-table-column>
          <!--
          <el-table-column width="100px" label="汇率" prop="exchange_rate">
            <template slot="header">
              <I18Lang id="proxymoneymanage42" defaultText="汇率" />
            </template>
          </el-table-column>
          -->
          <el-table-column width="110px" label="佣金($)" prop="commission">
            <template slot="header">
              <I18Lang id="proxymoneymanage43" defaultText="佣金($)" />
            </template>
          </el-table-column>
          <el-table-column label="用户ID" prop="account_id" width="120">
            <template slot="header">
              <I18Lang id="proxymoneymanage44" defaultText="用户ID" />
            </template>
          </el-table-column>
          <el-table-column width="120px" label="交易账号" prop="account_no">
            <template slot="header">
              <I18Lang id="proxymoneymanage45" defaultText="交易账号" />
            </template>
          </el-table-column>
          <el-table-column width="180" label="交易时间" prop="trade_deal_time">
            <template slot="header">
              <I18Lang id="proxymoneymanage56" defaultText="交易时间" />
            </template>
            <template slot-scope="scope">
              {{ formatTradeTime(scope.row.trade_deal_time) }}
            </template>
          </el-table-column>
          <el-table-column width="150px" label="交易产品" prop="trade_inst_name">
            <template slot="header">
              <I18Lang id="proxymoneymanage46" defaultText="交易产品" />
            </template>
          </el-table-column>
          <el-table-column width="120px" label="交易量" prop="trade_vol">
            <template slot="header">
              <I18Lang id="proxymoneymanage47" defaultText="交易量" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.trade_vol === -1 || scope.row.trade_vol === 0 ? '' : scope.row.trade_vol }}
            </template>
          </el-table-column>
          <el-table-column width="110px" label="交易价格" prop="trade_price">
            <template slot="header">
              <I18Lang id="proxymoneymanage48" defaultText="交易价格" />
            </template>
            <template slot-scope="scope">
              {{ formatTradePrice(scope.row.trade_price) }}
            </template>
          </el-table-column>
          <el-table-column label="开平仓" prop="trade_kp">
            <template slot="header">
              <I18Lang id="proxymoneymanage49" defaultText="开平仓" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.trade_kp === -1 ? '' : scope.row.trade_kp === 0 ? $t('proxymoneymanage50') :
            $t('proxymoneymanage51') }}
            </template>
          </el-table-column>
          <el-table-column label="买/卖" prop="trade_dc">
            <template slot="header">
              <I18Lang id="proxymoneymanage52" defaultText="买/卖" />
            </template>
            <template slot-scope="scope">
              {{ scope.row.trade_dc === -1 ? '' : scope.row.trade_dc === 0 ? $t('proxymoneymanage53') :
            $t('proxymoneymanage54') }}
            </template>
          </el-table-column>
          <el-table-column width="200" label="流水号" prop="stream_no">
            <template slot="header">
              <I18Lang id="proxymoneymanage55" defaultText="流水号" />
            </template>
          </el-table-column>

        </el-table>
        <div class="page">
          <el-pagination background @current-change="pageChange" layout="total, prev, pager, next"
            :total="tableData.total"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formateObjToParamStr } from '@utils'
import cookie from '@utils/cookie'
import { mapState } from 'vuex'
import { transferAccountTypes } from '@utils/global'
export default {
  name: 'record',
  data () {
    return {
      transferAccountTypes,
      transferTypesText: {
        1: this.$t('userstatement78'), // 转入
        2: this.$t('userstatement79') // 转出
      },
      queryDate: '',
      queryForm: {
        username: '',
        account_market: '3',
        account_mode: '',
        page: 1,
        size: 10
      },
      tableData: {
        list: [],
        total: 0
      },
      total_commission: ''
    }
  },
  created () {
    this.initData()
  },
  computed: {
    ...mapState(['userInfo', 'currMarket'])
  },
  methods: {
    initData () {
      this.queryForm.account_market = +cookie.get('national_market')
      this.getRecord()
    },
    importData () {
      const params = {
        token: cookie.get('kg-client-token'),
        ...this.queryForm,
        is_export: 1
      }
      window.open(
        `/api/agent/commissionDetailList?${formateObjToParamStr(
          params
        )}`
      )
    },
    // onAccountMarket (i) {
    //   this.queryForm.account_market = i
    //   this.getRecord()
    // },
    getRecord () {
      this.$http.post('/api/agent/commissionDetailList', this.queryForm).then(result => {
        this.tableData = result
        if (+this.queryForm.page === 1) {
          this.total_commission = result.total_commission
        }
      })
    },
    queryQuery () {
      this.pageChange(1)
    },
    resetQuery () {
      Object.keys(this.queryForm).map(item => {
        if (!['page', 'size', 'is_agent'].includes(item)) {
          this.queryForm[item] = ''
        }
      })
      this.queryForm.account_market = '3'
      this.queryDate = ''
      this.pageChange(1)
    },
    dateChange (val) {
      this.queryForm.start_time = val ? val[0] : ''
      this.queryForm.end_time = val ? val[1] : ''
    },
    formatTradeTime (value) {
      const text = String(value || '').trim()
      if (!text) return ''

      const pad = val => String(val).padStart(2, '0')
      const normalDate = text.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})[ T](\d{1,2}):(\d{1,2}):(\d{1,2})/)
      if (normalDate) {
        return `${normalDate[1]}-${pad(normalDate[2])}-${pad(normalDate[3])} ${pad(normalDate[4])}:${pad(normalDate[5])}:${pad(normalDate[6])}`
      }

      const englishDate = text.match(/^(\d{1,2})-([A-Za-z]{3})-(\d{4})[ T](\d{1,2}):(\d{1,2}):(\d{1,2})/)
      if (englishDate) {
        const months = {
          Jan: '01',
          Feb: '02',
          Mar: '03',
          Apr: '04',
          May: '05',
          Jun: '06',
          Jul: '07',
          Aug: '08',
          Sep: '09',
          Oct: '10',
          Nov: '11',
          Dec: '12'
        }
        const month = months[englishDate[2]]
        if (month) {
          return `${englishDate[3]}-${month}-${pad(englishDate[1])} ${pad(englishDate[4])}:${pad(englishDate[5])}:${pad(englishDate[6])}`
        }
      }

      return text
    },
    formatTradePrice (value) {
      const price = Number(value)
      if (!Number.isFinite(price) || price === -1 || price === 0) return ''
      return price.toFixed(2)
    },
    pageChange (page) {
      this.queryForm.page = page
      this.getRecord()
    }
  }
}
</script>
<style scoped lang="scss">
.statistics {
  font-size: 16px;
  font-weight: 400;
  color: #01B2F5;
  line-height: 51px;

  .num {
    color: #fff;
  }
}

.countrys {
  display: flex;
  margin-top: 15px;

  .countrys-item {
    width: 40px;
    height: 40px;
    margin-right: 50px;
    border: 2px solid transparent;
    cursor: pointer;

    &.item3 {
      background: url('../../../assets/img/country/yd.png') no-repeat center / 100% 100%;
    }

    &.item2 {
      background: url('../../../assets/img/country/xg.png') no-repeat center / 100% 100%;
    }

    &.item1 {
      background: url('../../../assets/img/country/en.png') no-repeat center / 100% 100%;
    }

    &.item4 {
      background: url('../../../assets/img/country/jp.png') no-repeat center / 100% 100%;
    }

    &.active {
      border: 2px solid #00CCFF;
      border-radius: 50%;
    }
  }
}

.reset-query {
  margin-top: 15px;
}
</style>
